<template>
  <div class="form-group">
    <ncs-label :id="`filters.${id}`"/>
    <multiselect v-model="selected"
                 :options="options"
                 track-by="value"
                 :custom-label="({ label }) => label"
                 group-values="values"
                 group-label="type"
                 :group-select="true"
                 :placeholder="tOr(`filters.${id}.options`, null)"
                 :searchable="true"
                 :multiple="true"
                 :allowEmpty="true"
                 :close-on-select="false"
                 :show-labels="false"
                 :disabled="false">
      <template v-slot:noResult>
        <span v-html="tOr(`filters.${id}.no_result`, t('filters.no_result'))"></span>
      </template>
    </multiselect>
  </div>
</template>
<script setup lang="ts">
import { includes } from 'lodash-es'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { computed } from "vue"
import { useFiltersStore, useNcsI18n } from "ncs"


const props = withDefaults(defineProps<{
  id: string
  elementFilterId: string
  elementType: string
  excludeInfos: string[]
}>(), {
  excludeInfos: []
})

const { t, tOr } = useNcsI18n()
const field = `${props.elementType}.searchable_info`
const options = [
  {
    type: 'Saludo / Presentación',
    values: [
      { label: 'Saludo / Presentación inicio', value: 'Saludo / Presentación' },
      { label: 'Saludo / Presentación respuesta', value: 'Saludo / Presentación respuesta' },
    ]
  },
  {
    type: 'Acto directivo',
    values: [
      { label: 'Acto directivo inicio', value: 'Acto directivo' },
      { label: 'Acto directivo respuesta', value: 'Acto directivo respuesta' },
    ]
  },
  {
    type: 'Ofrecimiento',
    values: [
      { label: 'Ofrecimiento inicio', value: 'Ofrecimiento' },
      { label: 'Ofrecimiento respuesta', value: 'Ofrecimiento respuesta' },
    ]
  },
  {
    type: 'Otras',
    values: ['Cita', 'Énfasis', 'Risa', 'Sigla']
        .filter(v => !props.excludeInfos.includes(v))
        .map(v => ({ label: v, value: v }))
  },
  {
    type: 'Pregunta',
    values: [
      { label: 'Interrogativa total', value: 'Pregunta interrogativa total' },
      { label: 'Interrogativa parcial', value: 'Pregunta interrogativa parcial' },
      { label: 'Interrogativa disyuntiva', value: 'Pregunta interrogativa disyuntiva' },
      { label: 'Interrogativa de eco', value: 'Pregunta interrogativa de eco' },
      { label: 'Interrogativa inconclusa', value: 'Pregunta interrogativa inconclusa' },
      { label: 'Enunciativa con confirmación', value: 'Pregunta enunciativa con confirmación' },
    ]
  },
  {
    type: 'Respuesta',
    values: [
      { label: 'Respuesta interrogativa total', value: 'Respuesta interrogativa total' },
      { label: 'Respuesta interrogativa parcial', value: 'Respuesta interrogativa parcial' },
      { label: 'Respuesta interrogativa disyuntiva', value: 'Respuesta interrogativa disyuntiva' },
      { label: 'Respuesta interrogativa de eco', value: 'Respuesta interrogativa de eco' },
      { label: 'Respuesta interrogativa inconclusa', value: 'Respuesta interrogativa inconclusa' },
      { label: 'Respuesta enunciativa con confirmación', value: 'Respuesta enunciativa con confirmación' },
    ]
  }
]

const filtersStore = useFiltersStore()
const filter = filtersStore.filters[props.elementFilterId]

const selected = computed({
  get: () => {
    return options.flatMap(g => g.values).filter(o => includes(filter.value, o.value))
  },
  set: (v) => {
    filter.value = v.map(o => o.value)
  }
})
</script>
<style lang="scss">
// Change vue-multiselect size to match default select
.multiselect {
  .multiselect__select {
    height: 32px; // Center right arrow
  }

  .multiselect__placeholder { // Avoid height change when selecting an option
    padding-top: 0;
    margin-bottom: 0;
  }
}
</style>
